// src/ui/primitives.jsx
import React from "react";
import { THEME, panelStyle, btnStyle } from "./theme";

export function Section({ title, subtitle, right, children, style }) {
  return (
    <div style={panelStyle({ padding: 12, ...style })}>
      {(title || subtitle || right) && (
        <div style={{ display: "flex", alignItems: "baseline", justifyContent: "space-between", gap: 10 }}>
          <div style={{ display: "grid", gap: 2 }}>
            {title && <div style={{ fontWeight: 950 }}>{title}</div>}
            {subtitle && <div style={{ fontSize: 12, color: THEME.muted }}>{subtitle}</div>}
          </div>
          {right && <div>{right}</div>}
        </div>
      )}

      {children && <div style={{ marginTop: title || subtitle || right ? 10 : 0 }}>{children}</div>}
    </div>
  );
}

export function Segment({ label, value, options, onChange, style }) {
  return (
    <div style={{ display: "flex", gap: 8, alignItems: "center", flexWrap: "wrap", ...style }}>
      {label && <span style={{ fontSize: 12, color: THEME.muted, fontWeight: 900 }}>{label}</span>}
      <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
        {(options || []).map(([v, txt, icon]) => (
          <button key={v} onClick={() => onChange?.(v)} style={btnStyle(value === v)}>
            {icon ? <span style={{ opacity: 0.9 }}>{icon}</span> : null}
            {txt}
          </button>
        ))}
      </div>
    </div>
  );
}

export function Card({ label, value, right, style }) {
  return (
    <div style={panelStyle({ padding: 12, minWidth: 0, ...style })}>
      <div style={{ display: "flex", justifyContent: "space-between", gap: 10, alignItems: "baseline" }}>
        <div style={{ fontSize: 12, color: THEME.muted, fontWeight: 900 }}>{label}</div>
        {right ? <div>{right}</div> : null}
      </div>
      <div style={{ fontSize: 18, fontWeight: 950, marginTop: 6 }}>{value}</div>
    </div>
  );
}

export function Pill({ children, tone = "muted", style }) {
  const tones = {
    muted: { background: "rgba(255,255,255,0.08)", border: `1px solid ${THEME.border}`, color: THEME.muted },
    ok: { background: "rgba(52,211,153,0.14)", border: "1px solid rgba(52,211,153,0.25)", color: THEME.green },
    warn: { background: "rgba(251,191,36,0.14)", border: "1px solid rgba(251,191,36,0.25)", color: THEME.amber },
    alert: { background: "rgba(251,113,133,0.14)", border: "1px solid rgba(251,113,133,0.25)", color: THEME.red },
  };

  const t = tones[tone] || tones.muted;

  return (
    <span
      style={{
        ...t,
        padding: "5px 10px",
        borderRadius: THEME.radiusPill,
        fontSize: 12,
        fontWeight: 950,
        display: "inline-flex",
        alignItems: "center",
        gap: 8,
        ...style,
      }}
    >
      {children}
    </span>
  );
}

export function EmptyState({ children, style }) {
  return (
    <div
      style={{
        padding: 12,
        borderRadius: 12,
        border: `1px dashed ${THEME.border}`,
        color: THEME.muted,
        fontSize: 12,
        ...style,
      }}
    >
      {children}
    </div>
  );
}

export function KV({ label, value, k, v, style }) {
  const _label = label ?? k;
  const _value = value ?? v;

  return (
    <div style={style}>
      <div style={{ fontSize: 11, color: THEME.muted, fontWeight: 900 }}>
        {_label}
      </div>
      <div style={{ fontSize: 12, color: THEME.text, marginTop: 2 }}>
        {_value}
      </div>
    </div>
  );
}